import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <h1>Congrats! You can apply for a driver's license!</h1>
    </header>
  );
};

export default Header;
